import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { SuccessActionResultComponent } from '../../dialogs/success-action-result/success-action-result.component';

export class CheckoutCommonResources {

    constructor(
        protected dialogsService: DialogsService,
        protected router: Router,
    ) { }

    /**
     * Mostra um mensagem de sucesso.Usada ao fim de uma ação
     * @param message Mensagem a ser mostrada (aceita HTML)
     * @param title título do diálogo
     * @param iconName ícone a ser usado
     */
    protected showSuccessMessageResult(receiptTitle: string, body: string, iconName: string = null) {
        this.dialogsService.showComponnent(SuccessActionResultComponent, {
            message: body,
            title: receiptTitle,
            icon: iconName,
        });
    }

    /**
     * Alerta o usuário sobre a garantia insuficiente para o investimento
     */
    protected showInsufficientGuaranteeWarning() {
        this.dialogsService.showSimpleModal(
        'icon_info',
        'Garantia insuficiente',
        `Você não tem garantia suficiente para fazer esse investimento. Você pode transferir mais recursos para a sua conta e tentar novamente.`,
        `Voltar`);
    }

    /**
     * Alerta o usuário sobre o saldo insuficiente para o investimento
     */
    protected showInsufficientFundsWarning() {
        this.dialogsService.showSimpleModal(
        'icon_info',
        'Saldo insuficiente',
        `Você não tem saldo suficiente para fazer este investimento. Você pode transferir mais recursos para a sua conta e tentar novamente.`,
        `Voltar`);
    }

    /**
     * Alerta o usuário sobre a garantia insuficiente ao tentar desligar daytrade
     */
    protected showInsufficientGuaranteeDayTrade() {
        this.dialogsService.showSimpleModal(
        'icon_info',
        'Garantia insuficiente',
        `Você não tem garantia suficiente para alterar a estratégia de encerrar hoje o investimento.`,
        `Voltar`);
    }

     /**
     * Alerta o usuário que ele está bloqueado e precisa atualizar os dados de acordo com a RCVM 50
     */
      protected showWarningUserBlockedIcvm617() {
        const message =
            `<p>A Resolução 50 da CVM exige que todos os investidores atualizem algumas informações de cadastro.
            Por isso, até que você atualize os seus dados, <b>sua conta está bloqueada para novas operações</b>.

            <br/> <br/>
            Clique no botão abaixo para conferir as informações e voltar a investir normalmente.</p><br/>`;

        this.dialogsService
            .confirmDestructiveAction(
                'Atualize seus dados cadastrais para concluir a operação',
                message,
                'Atualizar dados cadastrais',
                'Deixar para depois',
            )
            .subscribe((data) => {
                if (data) {
                    this.router.navigate(['minha-conta/risco/edit']);
                }
            });
    }
}
